const statesWithCities = {
  "Andaman and Nicobar Islands": [
    "Port Blair",
    "Diglipur",
    "Mayabunder",
    "Rangat",
    "Hut Bay",
    "Neil Island",
    "Havelock Island",
    "Little Andaman",
    "Campbell Bay",
    "Car Nicobar",
  ],

  "Andhra Pradesh": [
    "Adoni",
    "Amalapuram",
    "Anakapalle",
    "Anantapur",
    "Bapatla",
    "Bheemunipatnam",
    "Bhimavaram",
    "Bobbili",
    "Chilakaluripet",
    "Chittoor",
    "Dharmavaram",
    "Eluru",
    "Gooty",
    "Gudivada",
    "Gudur",
    "Guntakal",
    "Guntur",
    "Hindupur",
    "Kadapa",
    "Kakinada",
    "Kavali",
    "Kurnool",
    "Machilipatnam",
    "Madanapalle",
    "Mandapeta",
    "Markapur",
    "Nandyal",
    "Narasaraopet",
    "Narsapur",
    "Nellore",
    "Ongole",
    "Palacole",
    "Proddatur",
    "Punganur",
    "Puttur",
    "Rajahmundry",
    "Rajampet",
    "Rayachoti",
    "Rayadurg",
    "Renigunta",
    "Samalkot",
    "Sattenapalle",
    "Srikakulam",
    "Tadepalligudem",
    "Tadpatri",
    "Tanuku",
    "Tenali",
    "Tirupati",
    "Tuni",
    "Uravakonda",
    "Venkatagiri",
    "Vijayawada",
    "Vinukonda",
    "Visakhapatnam",
    "Vizianagaram",
    "Yemmiganur",
  ],

  "Arunachal Pradesh": [
    "Along",
    "Anini",
    "Basar",
    "Bomdila",
    "Changlang",
    "Daporijo",
    "Dibang Valley",
    "Dirang",
    "Hayuliang",
    "Itanagar",
    "Khonsa",
    "Koloriang",
    "Lohit",
    "Longding",
    "Mechuka",
    "Naharlagun",
    "Namsai",
    "Pasighat",
    "Roing",
    "Seppa",
    "Tawang",
    "Tezu",
    "Yingkiong",
    "Ziro",
  ],
  Assam: [
    "Baksa",
    "Barpeta",
    "Bongaigaon",
    "Chirang",
    "Dhemaji",
    "Dhubri",
    "Dibrugarh",
    "Diphu",
    "Goalpara",
    "Golaghat",
    "Guwahati",
    "Hailakandi",
    "Hojai",
    "Jorhat",
    "Karimganj",
    "Kokrajhar",
    "Lakhimpur",
    "Majuli",
    "Mangaldoi",
    "Morigaon",
    "Nagaon",
    "Nalbari",
    "North Lakhimpur",
    "Rangia",
    "Silchar",
    "Sivasagar",
    "Tezpur",
    "Tinsukia",
    "Udalguri",
  ],

  Bihar: [
    "Ara",
    "Araria",
    "Aurangabad",
    "Bagaha",
    "Barh",
    "Begusarai",
    "Bettiah",
    "Bhagalpur",
    "Bihar Sharif",
    "Buxar",
    "Chapra",
    "Darbhanga",
    "Dehri",
    "Dumraon",
    "Forbesganj",
    "Gaya",
    "Hajipur",
    "Hilsa",
    "Jamui",
    "Jehanabad",
    "Katihar",
    "Khagaria",
    "Kishanganj",
    "Lakhisarai",
    "Madhepura",
    "Madhubani",
    "Motihari",
    "Motipur",
    "Munger",
    "Muzaffarpur",
    "Narkatiaganj",
    "Nawada",
    "Patna",
    "Purnia",
    "Raxaul",
    "Saharsa",
    "Samastipur",
    "Sasaram",
    "Sheikhpura",
    "Sheohar",
    "Sitamarhi",
    "Siwan",
  ],

  Chhattisgarh: [
    "Raipur",
    "Bhilai",
    "Bilaspur",
    "Korba",
    "Rajnandgaon",
    "Durg",
    "Jagdalpur",
    "Ambikapur",
    "Raigarh",
    "Dhamtari",
    "Mahasamund",
    "Kanker",
    "Kawardha",
    "Janjgir",
    "Champa",
    "Bemetara",
    "Dantewada",
    "Kondagaon",
    "Surguja",
    "Surajpur",
    "Balrampur",
    "Balod",
    "Baloda Bazar",
    "Gariaband",
    "Mungeli",
    "Sukma",
    "Bijapur",
    "Narayanpur",
    "Gaurela-Pendra-Marwahi",
  ],

  Chandigarh: [
    "Chandigarh",
    "Manimajra",
    "Sector 17",
    "Sector 22",
    "Sector 43",
    "Daria",
    "Maloya",
    "Sarangpur",
    "Burail",
    "Hallomajra",
  ],

  "Dadra and Nagar Haveli and Daman and Diu": [
    "Silvassa",
    "Daman",
    "Diu",
    "Amli",
    "Naroli",
    "Samarvarni",
    "Kachigam",
    "Bhimpore",
    "Marwad",
    "Varkund",
  ],

  Goa: [
    "Panaji",
    "Margao",
    "Vasco da Gama",
    "Mapusa",
    "Ponda",
    "Bicholim",
    "Curchorem",
    "Canacona",
    "Sanquelim",
    "Quepem",
    "Sanguem",
    "Valpoi",
    "Mormugao",
    "Cuncolim",
    "Pernem",
    "Chicalim",
    "Assagao",
    "Porvorim",
    "Calangute",
    "Candolim",
    "Siolim",
    "Tivim",
    "Aldona",
    "Saligao",
    "Colva",
    "Fatorda",
    "Navelim",
    "Dabolim",
    "Caranzalem",
    "Dona Paula",
  ],

  Gujarat: [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Bhavnagar",
    "Jamnagar",
    "Junagadh",
    "Gandhinagar",
    "Anand",
    "Nadiad",
    "Mehsana",
    "Bharuch",
    "Navsari",
    "Vapi",
    "Gandhidham",
    "Porbandar",
    "Palanpur",
    "Morbi",
    "Surendranagar",
    "Amreli",
    "Godhra",
    "Veraval",
    "Valsad",
    "Botad",
    "Dahod",
    "Kalol",
    "Petlad",
    "Wadhwan",
    "Dhoraji",
    "Jetpur",
    "Modasa",
    "Visnagar",
    "Padra",
    "Una",
    "Mangrol",
    "Kadi",
    "Khambhat",
    "Deesa",
    "Viramgam",
    "Lunawada",
    "Thangadh",
    "Sidhpur",
    "Sanand",
    "Savarkundla",
    "Manavadar",
  ],

  Haryana: [
    "Gurgaon",
    "Faridabad",
    "Panipat",
    "Ambala",
    "Rohtak",
    "Karnal",
    "Hisar",
    "Yamunanagar",
    "Sonipat",
    "Panchkula",
    "Bhiwani",
    "Bahadurgarh",
    "Sirsa",
    "Rewari",
    "Kaithal",
    "Palwal",
    "Jind",
    "Kurukshetra",
    "Mahendragarh",
    "Fatehabad",
    "Narwana",
    "Tosham",
    "Charkhi Dadri",
    "Narnaul",
    "Nuh",
    "Hansi",
    "Gohana",
    "Kalka",
    "Safidon",
    "Samalkha",
  ],

  "Himachal Pradesh": [
    "Shimla",
    "Manali",
    "Dharamshala",
    "Solan",
    "Kullu",
    "Mandi",
    "Bilaspur",
    "Chamba",
    "Una",
    "Hamirpur",
    "Nahan",
    "Palampur",
    "Kangra",
    "Kinnaur",
    "Keylong",
    "Sundernagar",
    "Paonta Sahib",
    "Rampur",
    "Rohru",
    "Nalagarh",
    "Theog",
    "Baddi",
    "Joginder Nagar",
    "Tira Sujanpur",
    "Karsog",
  ],
  Jharkhand: [
    "Ranchi",
    "Jamshedpur",
    "Dhanbad",
    "Bokaro",
    "Deoghar",
    "Hazaribagh",
    "Giridih",
    "Ramgarh",
    "Chaibasa",
    "Dumka",
    "Phusro",
    "Medininagar (Daltonganj)",
    "Chirkunda",
    "Sahibganj",
    "Jhumri Tilaiya",
    "Lohardaga",
    "Gumia",
    "Chatra",
    "Simdega",
    "Pakur",
    "Latehar",
    "Bermo",
    "Godda",
    "Khunti",
    "Garhwa",
    "Madhupur",
    "Saraikela",
    "Barharwa",
    "Basukinath",
    "Jasidih",
  ],

  "Jammu and Kashmir": [
    "Srinagar",
    "Jammu",
    "Anantnag",
    "Baramulla",
    "Udhampur",
    "Kathua",
    "Kupwara",
    "Pulwama",
    "Budgam",
    "Rajouri",
    "Poonch",
    "Ganderbal",
    "Shopian",
    "Bandipora",
    "Kulgam",
  ],
  Karnataka: [
    "Bangalore",
    "Mysore",
    "Mangalore",
    "Hubli",
    "Belgaum",
    "Davanagere",
    "Bellary",
    "Tumkur",
    "Shimoga",
    "Bidar",
    "Hospet",
    "Raichur",
    "Bijapur",
    "Gulbarga",
    "Chitradurga",
    "Hassan",
    "Bagalkot",
    "Kolar",
    "Udupi",
    "Chikmagalur",
    "Karwar",
    "Mandya",
    "Haveri",
    "Ramanagara",
    "Chikkaballapur",
    "Yadgir",
    "Sirsi",
    "Bhadravati",
    "Gangavati",
    "Tiptur",
    "Nanjangud",
    "Madikeri",
    "Sagar",
    "Puttur",
    "Basavakalyan",
  ],
  Kerala: [
    "Thiruvananthapuram",
    "Kochi",
    "Kozhikode",
    "Thrissur",
    "Kollam",
    "Alappuzha",
    "Palakkad",
    "Kannur",
    "Kottayam",
    "Malappuram",
    "Pathanamthitta",
    "Idukki",
    "Wayanad",
    "Chengannur",
    "Kayamkulam",
    "Kunnamkulam",
    "Punalur",
    "Chalakudy",
    "Perinthalmanna",
    "Thodupuzha",
    "Neyyattinkara",
    "Varkala",
    "Manjeri",
    "Ottapalam",
    "Tirur",
    "Vadakara",
    "Kasaragod",
    "Muvattupuzha",
    "Adoor",
    "Ponnani",
  ],

  Ladakh: [
    "Leh",
    "Kargil",
    "Diskit",
    "Nubra",
    "Dras",
    "Padum",
    "Tangtse",
    "Turtuk",
    "Nyoma",
    "Sankoo",
  ],

  Lakshadweep: [
    "Kavaratti",
    "Agatti",
    "Minicoy",
    "Amini",
    "Kadmat",
    "Kalpeni",
    "Andrott",
    "Chetlat",
    "Bitra",
    "Kiltan",
  ],
  "Madhya Pradesh": [
    "Bhopal",
    "Indore",
    "Jabalpur",
    "Gwalior",
    "Ujjain",
    "Sagar",
    "Satna",
    "Ratlam",
    "Rewa",
    "Dewas",
    "Chhindwara",
    "Morena",
    "Bhind",
    "Burhanpur",
    "Vidisha",
    "Katni",
    "Shivpuri",
    "Hoshangabad",
    "Neemuch",
    "Mandsaur",
    "Sehore",
    "Itarsi",
    "Khandwa",
    "Damoh",
    "Betul",
    "Singrauli",
    "Seoni",
    "Raisen",
    "Datia",
    "Dhar",
    "Chhatarpur",
    "Shahdol",
    "Panna",
    "Anuppur",
    "Mandla",
  ],
  Maharashtra: [
    "Mumbai",
    "Pune",
    "Nagpur",
    "Nashik",
    "Thane",
    "Aurangabad",
    "Solapur",
    "Amravati",
    "Kolhapur",
    "Nanded",
    "Sangli",
    "Jalgaon",
    "Akola",
    "Latur",
    "Ahmednagar",
    "Chandrapur",
    "Parbhani",
    "Dhule",
    "Beed",
    "Wardha",
    "Satara",
    "Gondia",
    "Bhandara",
    "Hingoli",
    "Osmanabad",
    "Ratnagiri",
    "Sindhudurg",
    "Yavatmal",
    "Panvel",
    "Ulhasnagar",
    "Kalyan",
    "Vasai-Virar",
    "Navi Mumbai",
    "Mira-Bhayandar",
    "Ambarnath",
    "Baramati",
    "Sinnar",
    "Karad",
    "Ichalkaranji",
    "Manmad",
    "Jalna",
    "Washim",
    "Nandurbar",
    "Malegaon",
    "Bhiwandi",
  ],
  Manipur: [
    "Imphal",
    "Thoubal",
    "Bishnupur",
    "Churachandpur",
    "Ukhrul",
    "Kakching",
    "Senapati",
    "Tamenglong",
    "Chandel",
    "Jiribam",
    "Moreh",
    "Moirang",
    "Nambol",
    "Yairipok",
    "Lilong",
    "Wangjing",
    "Kumbi",
    "Sugnu",
    "Lamsang",
    "Andro",
  ],
  Meghalaya: [
    "Shillong",
    "Tura",
    "Nongpoh",
    "Jowai",
    "Baghmara",
    "Williamnagar",
    "Resubelpara",
    "Nongstoin",
    "Mairang",
    "Mawkyrwat",
    "Khliehriat",
    "Ampati",
    "Sohra (Cherrapunji)",
    "Dawki",
    "Umiam",
    "Byrnihat",
    "Mendipathar",
    "Garobadha",
    "Rongram",
    "Phulbari",
  ],
  Mizoram: [
    "Aizawl",
    "Lunglei",
    "Champhai",
    "Serchhip",
    "Kolasib",
    "Saiha",
    "Lawngtlai",
    "Mamit",
    "Khawzawl",
    "Hnahthial",
    "Saitual",
    "North Vanlaiphai",
    "Zemabawk",
    "Bairabi",
    "Vairengte",
    "Sairang",
    "Tlabung",
    "Thenzawl",
    "Zawlnuam",
    "Ngopa",
  ],
  Nagaland: [
    "Kohima",
    "Dimapur",
    "Mokokchung",
    "Tuensang",
    "Zunheboto",
    "Wokha",
    "Mon",
    "Phek",
    "Kiphire",
    "Longleng",
    "Peren",
    "Chümoukedima",
    "Medziphema",
    "Tuli",
    "Tseminyu",
    "Noklak",
    "Chizami",
    "Pfutsero",
    "Jalukie",
    "Aboi",
  ],
  Odisha: [
    "Bhubaneswar",
    "Cuttack",
    "Rourkela",
    "Puri",
    "Sambalpur",
    "Berhampur",
    "Balasore",
    "Baripada",
    "Bhadrak",
    "Jharsuguda",
    "Angul",
    "Dhenkanal",
    "Paradip",
    "Kendrapara",
    "Rayagada",
    "Koraput",
    "Jeypore",
    "Phulbani",
    "Nabarangpur",
    "Bargarh",
    "Sundargarh",
    "Keonjhar",
    "Talcher",
    "Kalahandi",
    "Jagatsinghpur",
    "Subarnapur",
    "Malkangiri",
    "Nuapada",
    "Kandhamal",
    "Boudh",
  ],
  Punjab: [
    "Ludhiana",
    "Amritsar",
    "Jalandhar",
    "Patiala",
    "Bathinda",
    "Mohali",
    "Hoshiarpur",
    "Moga",
    "Pathankot",
    "Firozpur",
    "Barnala",
    "Sangrur",
    "Kapurthala",
    "Khanna",
    "Phagwara",
    "Malerkotla",
    "Abohar",
    "Faridkot",
    "Rupnagar",
    "Fazilka",
    "Tarn Taran",
    "Gurdaspur",
    "Nawanshahr",
    "Muktsar",
    "Zirakpur",
    "Gobindgarh",
    "Rajpura",
    "Samana",
    "Mansa",
    "Dasuya",
  ],
  Rajasthan: [
    "Jaipur",
    "Udaipur",
    "Jodhpur",
    "Ajmer",
    "Kota",
    "Bikaner",
    "Alwar",
    "Bhilwara",
    "Sikar",
    "Pali",
    "Tonk",
    "Bharatpur",
    "Chittorgarh",
    "Barmer",
    "Hanumangarh",
    "Sri Ganganagar",
    "Nagaur",
    "Beawar",
    "Dungarpur",
    "Jhunjhunu",
    "Sawai Madhopur",
    "Jaisalmer",
    "Banswara",
    "Churu",
    "Dausa",
    "Sirohi",
    "Karauli",
    "Pratapgarh",
    "Abu Road",
    "Phalodi",
  ],
  Sikkim: [
    "Gangtok",
    "Namchi",
    "Gyalshing",
    "Mangan",
    "Rangpo",
    "Jorethang",
    "Singtam",
    "Soreng",
    "Chungthang",
    "Pakyong",
    "Ravangla",
    "Yuksom",
    "Dentam",
    "Zuluk",
    "Lachung",
    "Lachen",
    "Tsomgo",
    "Phodong",
    "Melli",
    "Tashiding",
  ],
  "Tamil Nadu": [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Salem",
    "Erode",
    "Tiruchirappalli",
    "Tirunelveli",
    "Vellore",
    "Thoothukudi",
    "Dindigul",
    "Thanjavur",
    "Karur",
    "Tiruppur",
    "Nagercoil",
    "Cuddalore",
    "Villupuram",
    "Kanchipuram",
    "Nagapattinam",
    "Tiruvannamalai",
    "Sivakasi",
    "Pollachi",
    "Ambur",
    "Pudukkottai",
    "Ranipet",
    "Ariyalur",
    "Perambalur",
    "Dharmapuri",
    "Krishnagiri",
    "Namakkal",
    "Virudhunagar",
    "Hosur",
    "Arakkonam",
    "Palani",
    "Tambaram",
    "Gudiyatham",
  ],
  Telangana: [
    "Adilabad",
    "Bellampalli",
    "Bhadrachalam",
    "Bhongir",
    "Bodhan",
    "Gadwal",
    "Hyderabad",
    "Jagtial",
    "Jangaon",
    "Kamareddy",
    "Karimnagar",
    "Khammam",
    "Kodad",
    "Koratla",
    "Mahbubabad",
    "Mahbubnagar",
    "Mancherial",
    "Medak",
    "Miryalaguda",
    "Nalgonda",
    "Narayankhed",
    "Narsampet",
    "Nirmal",
    "Nizamabad",
    "Palwancha",
    "Ramagundam",
    "Sangareddy",
    "Siddipet",
    "Sircilla",
    "Suryapet",
    "Tandur",
    "Vikarabad",
    "Wanaparthy",
    "Warangal",
    "Yadagirigutta",
  ],
  Tripura: [
    "Agartala",
    "Udaipur",
    "Dharmanagar",
    "Kailasahar",
    "Belonia",
    "Ambassa",
    "Khowai",
    "Santirbazar",
    "Teliamura",
    "Kamalpur",
    "Sonamura",
    "Panisagar",
    "Melaghar",
    "Bishalgarh",
    "Ranirbazar",
    "Sabroom",
    "Jogendranagar",
    "Mohanpur",
    "Barjala",
    "Gakulnagar",
  ],
  "Uttar Pradesh": [
    "Lucknow",
    "Kanpur",
    "Varanasi",
    "Agra",
    "Noida",
    "Ghaziabad",
    "Meerut",
    "Prayagraj",
    "Bareilly",
    "Aligarh",
    "Moradabad",
    "Saharanpur",
    "Gorakhpur",
    "Jhansi",
    "Faizabad",
    "Mathura",
    "Firozabad",
    "Ayodhya",
    "Rampur",
    "Muzaffarnagar",
    "Etawah",
    "Sitapur",
    "Shahjahanpur",
    "Ballia",
    "Raebareli",
    "Banda",
    "Barabanki",
    "Fatehpur",
    "Azamgarh",
    "Basti",
    "Bijnor",
    "Lakhimpur",
    "Hardoi",
    "Unnao",
    "Sultanpur",
    "Hapur",
    "Bulandshahr",
    "Amroha",
    "Jaunpur",
    "Gonda",
  ],
  Uttarakhand: [
    "Dehradun",
    "Haridwar",
    "Haldwani",
    "Roorkee",
    "Nainital",
    "Rishikesh",
    "Kashipur",
    "Rudrapur",
    "Pithoragarh",
    "Almora",
    "Tehri",
    "Kotdwar",
    "Bageshwar",
    "Champawat",
    "Mussoorie",
    "Srinagar",
    "Vikasnagar",
    "Pauri",
    "Tanakpur",
    "Doiwala",
    "Manglaur",
    "Devprayag",
    "Ranikhet",
    "Barkot",
    "Ghansali",
  ],
  "West Bengal": [
    "Kolkata",
    "Asansol",
    "Siliguri",
    "Durgapur",
    "Howrah",
    "Bardhaman",
    "Malda",
    "Kharagpur",
    "Berhampore",
    "Jalpaiguri",
    "Balurghat",
    "Bankura",
    "Habra",
    "Barasat",
    "Raiganj",
    "Krishnanagar",
    "Haldia",
    "Chinsurah",
    "Serampore",
    "Midnapore",
    "Alipurduar",
    "Bongaon",
    "Basirhat",
    "Cooch Behar",
    "Darjeeling",
    "Santipur",
    "Raichak",
    "Raghunathganj",
    "Rampurhat",
    "Dhulian",
  ],
  Delhi: [
    "New Delhi",
    "Dwarka",
    "Rohini",
    "Saket",
    "Karol Bagh",
    "Connaught Place",
    "Lajpat Nagar",
    "Chanakyapuri",
    "Janakpuri",
    "Pitampura",
    "Vasant Kunj",
    "Nehru Place",
    "Okhla",
    "Mayur Vihar",
    "Greater Kailash",
    "Rajouri Garden",
    "Tilak Nagar",
    "Malviya Nagar",
    "Model Town",
    "Shahdara",
    "Patel Nagar",
    "Laxmi Nagar",
    "Ashok Vihar",
    "Vikaspuri",
    "Nangloi",
    "Palam",
    "Kalkaji",
    "Green Park",
    "Preet Vihar",
    "Mehrauli",
  ],
};

export default statesWithCities;
